import React, { useEffect, useState } from 'react'
import { Tag } from 'antd';
import { ApiService } from '../../../services';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Transition } from '../general-transition';
import { PageTitle } from '../../molecules/page-title';
import { TableCustom } from '../table';
import { AtomicButton } from '../../atoms/button';
import { LoaderAtom } from '../../atoms/loading';

export const PurchaseModule = () => {
    const [purchases, setPurchases] = useState(null);
    const { t } = useTranslation();
    const history = useHistory();
    const getPurchases = async () => {
      const { data } = await ApiService.PurchaseService.getPurchases();
      console.log(data);
      setPurchases(data.data.purchases);
    };
    useEffect(() => getPurchases(), [])
    const columns = [
      /* {
        title: 'Company',
        dataIndex: 'company',
        key: 'company'
      }, */
      {
        title: 'Estado',
        dataIndex: 'status',
        render: (text, record) => (
          <Tag color='blue'>
            {record.status.toUpperCase()}
          </Tag>
        ),
      },
      /* {
        title: 'Tipo',
        dataIndex: 'type',
        key: 'type'
      },
      {
        title: 'Origen',
        dataIndex: 'origin',
        key: 'origin'
      },
      {
        title: 'Destino',
        dataIndex: 'destination',
        key: 'destination'
      }, */
      /* {
        title: 'ITR',
        dataIndex: 'itr',
        key: 'itr',
        render: (text) => text ? 'Incluido' : 'No incluido'
      },
      {
        title: 'Devolución',
        dataIndex: 'return2port',
        key: 'return2port',
        render: (text) => text ? 'Incluido' : 'No incluido'
      }, 
      {
        title: 'Cargue',
        dataIndex: 'load',
        key: 'load',
        render: (text) => text ? 'Incluido' : 'No incluido'
      },
      {
        title: 'Descargue',
        dataIndex: 'unload',
        key: 'unload',
        render: (text) => text ? 'Incluido' : 'No incluido'
      },
      {
        title: 'Peso (Kg)',
        dataIndex: 'weight',
        key: 'weight'
      },
      {
        title: 'Observaciones',
        dataIndex: 'obs',
        key: 'obs'
      },
      {
        title: 'Fecha',
        dataIndex: 'created_at',
        key: 'created_at',
        render: (text) => new Date(text).toLocaleDateString()
      },*/
      {
        title: 'Valor',
        dataIndex: 'value',
        key: 'value'
      },
      {
        title: 'Action',
        key: 'action',
        render: (text, record) => (
          <AtomicButton onClick={() => history.push(`/purchase/${record.id}`)}>+ Info</AtomicButton>
        ),
        fixed: 'right'
      }
    ];
    if(!purchases)return <LoaderAtom />;
    return (
        <Transition>
            <PageTitle title={t('Compras')} />
            <AtomicButton onClick={() => history.push('/create-purchase')}>Crear compra</AtomicButton>
            <br />
            <TableCustom
                columns={columns} 
                data={purchases} 
                searchableTable={true}
                searchablePlaceholder="Transporte"  
                serachableObjKey='purchase_consec'
            />
        </Transition>
    )
};